const HEX_DIGITS = '0123456789abcdef';
const VARIANT_DIGITS = '89ab';
const VERSION_POSITION = 14;
const VARIANT_POSITION = 19;

const pick = (digits: string) =>
  digits[Math.floor(Math.random() * digits.length)];

const randomIdentifier = () =>
  'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
    .split('')
    .map((character, position) => {
      if (character !== 'x') return character;
      if (position === VERSION_POSITION) return '4';
      if (position === VARIANT_POSITION) return pick(VARIANT_DIGITS);

      return pick(HEX_DIGITS);
    })
    .join('');

export default function generateCartIdentifier(): string {
  const nativeGenerator = globalThis.crypto?.randomUUID;

  if (typeof nativeGenerator === 'function') {
    return globalThis.crypto.randomUUID();
  }

  return randomIdentifier();
}
